<mat-dialog-content class="modal-header"
  ><h2 mat-dialog-title>REGISTRO DE USUARIO</h2></mat-dialog-content
>
<mat-dialog-content class="modal-body">
  <div class="block-content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-1 control-label">Tipo:</label>
        <div class="col-md-5">
          <mat-form-field appearance="outline">
            <mat-label>Seleccionar</mat-label>
            <mat-select
              matSelect
              [(ngModel)]="model.idTipo"
              (selectionChange)="changeTipoUsuario()"
              [disabled]="model.idUsuario != 0"
            >
              <mat-option [value]="1">ENGIE</mat-option>
              <mat-option [value]="2">CONTRATISTA</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <label class="col-md-1 control-label" *ngIf="model.idUsuario == 0 && model.idTipo == 1">Usuario:</label>
        <div class="col-md-5" >
          
          <mat-form-field
            class="example-full-width"
            appearance="outline"
            *ngIf="model.idUsuario == 0 && model.idTipo == 1"
          >
            <mat-label>Usuario (*):</mat-label>
            <input
              type="text"
              placeholder=""
              aria-label="Number"
              matInput
              [formControl]="myControl"
              [matAutocomplete]="auto"
              name="codigoUsuario"
              maxlength="160"
            />
            <mat-autocomplete
              autoActiveFirstOption
              #auto="matAutocomplete"
              [displayWith]="displayFn"
              (optionSelected)='verificarUsuario($event)'
            >
              <mat-option
                *ngFor="let option of filteredOptions | async"
                [value]="option"
              >
                {{ option.firstName + " " + option.lastName + " - " + option.email  }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <label *ngIf="existeEmpleado" class="label-required">El Usuario ya se encuentra registrado.</label>
        </div>
      </div>
      
      <div class="form-group" >
        <label class="col-md-1 control-label">Nombres (*):</label>
        <div class="col-md-5">
          <mat-form-field appearance="outline">
            <mat-label>Nombres</mat-label>
            <input matInput type="text" [(ngModel)]="model.nombres" [disabled]="model.idTipo == 1" maxlength="40" />
          </mat-form-field>
        </div>
        <label class="col-md-1 control-label">Apellidos (*):</label>
        <div class="col-md-5">
          <mat-form-field appearance="outline">
            <mat-label>Apellidos</mat-label>
            <input matInput type="text" [(ngModel)]="model.apellidos" [disabled]="model.idTipo == 1" maxlength="40" />
          </mat-form-field>
        </div>
      </div>
      
      <div class="form-group" *ngIf="model.idTipo == 2">
        <label class="col-md-1 control-label" >Correo (*):</label>
        <div class="col-md-5">
        <mat-form-field
            class="example-full-width"
            appearance="outline"
            *ngIf="model.idTipo == 2 || model.idUsuario !== 0"
          >
            <mat-label>Correo:</mat-label>
            <input
              type="text"
              placeholder=""
              aria-label="Number"
              matInput
              [(ngModel)]="model.correo"
              name="correo"
              [disabled]="model.idUsuario !== 0"
              (blur)="verificarCorreo($event)"
              maxlength="160"              
            />
          </mat-form-field>
          <label *ngIf="existeContratista" class="label-required">El correo ya se encuentra registrado.</label>
        </div>
        <label class="col-md-1 control-label" >Empresa (*):</label>
        <div class="col-md-5" >
          <mat-form-field appearance="outline">
            <mat-label>Empresa</mat-label>
            <input
              type="text"
              placeholder=""
              aria-label="Number"
              matInput
              [formControl]="contratistaControl"
              [matAutocomplete]="autoContratista"
              name="idContratista"
              maxlength="40"
            />
            <mat-autocomplete
              autoActiveFirstOption
              #autoContratista="matAutocomplete"
              [displayWith]="displayContratista"
              (optionSelected)="getContratista($event.option.value)"
            >
              <mat-option
                *ngFor="let option of contratistasOpcionesFiltradas | async"
                [value]="option"
              >
                {{ option.nombre }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        
      </div>
      <div class="form-group">
        <label class="col-md-1 control-label">Roles (*):</label>
        <div class="col-md-5">
          <mat-form-field appearance="outline">
            <mat-label>Roles</mat-label>
            <mat-select
              [(ngModel)]="model.selectedRoles"
              [disabled]="model.idTipo == 2"
              multiple
            >
              <mat-option *ngFor="let role of listaRoles" [value]="role.idRol">
                {{ role.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <label class="col-md-1 control-label">Sedes (*):</label>
        <div class="col-md-5">
          <mat-form-field appearance="outline">
            <mat-label>Sedes</mat-label>
            <mat-select [(ngModel)]="model.selectedSedes" multiple>
              <mat-option *ngFor="let sede of listaSedes" [value]="sede.idSede">
                {{ sede.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-1 control-label">Compañía (*):</label>
        <div class="col-md-5">
          <mat-form-field appearance="outline">
            <mat-label> Compañía </mat-label>
            <mat-select matSelect [(ngModel)]="model.selectedCompanias" multiple>
              <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                {{ company.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <label class="col-md-1 control-label">Estado (*):</label>
            <div class="col-md-5">
              <mat-form-field appearance="outline">
                <mat-label>
                  Seleccione
                </mat-label>
                <mat-select matSelect [(ngModel)]="model.idEstado">
                  <mat-option *ngFor="let item of paramsEstados; index as i;" [value]='item.idParametroDetalle'>{{item.valor}}</mat-option>
                </mat-select>
              </mat-form-field>   
            </div>  
      </div>

    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button
    class="btn btn-naranja"
    mat-button
    [mat-dialog-close]="model"
    (click)="Save()"
    
    [disabled]="validForm()"
    cdkFocusInitial
  >
    Guardar
  </button>
  <button class="btn btn-celeste" mat-button (click)="onNoClick()">
    Cancelar
  </button>
</mat-dialog-actions>
<!-- [disabled]="(model.idTipo == 1 && !existeEmpleado) || (model.idTipo == 2 && existeContratista)" -->
<!-- <pre>{{model | json}}</pre> -->
<!-- <pre>{{roles | json}}</pre> -->
<!-- <pre>{{roles | json}}</pre> -->
<!-- <pre>{{data | json}}</pre> -->
